import { render, staticRenderFns } from "./StoreBill.vue?vue&type=template&id=3c0b1d20&scoped=true"
import script from "./StoreBill.vue?vue&type=script&lang=js"
export * from "./StoreBill.vue?vue&type=script&lang=js"
import style0 from "./StoreBill.vue?vue&type=style&index=0&id=3c0b1d20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b1d20",
  null
  
)

export default component.exports